import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Divider, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import utilOperations from "../utils/operations";
import ExhibitADetail from "./ExhibitADetail";

const StyledRootButton = styled(Button)({
    border: "2px dashed #2C99D2",
    color: "#2C99D2",
    margin: "10px 0 20px",
    padding: "11px 16px",
    width: "100%",
    justifyContent: "start",
    "&:hover": {
        backgroundColor: "rgba(44, 153, 210, 0.08)",
    },
});

const StyledTable = styled("table")({
    borderCollapse: "collapse",
    width: "100%",
});

const StyledArchiveLabel = styled("span")({
    color: "rgba(0, 0, 0, 0.6)",
    fontWeight: "600",
    fontSize: "13px",
    marginRight: "5px",
    minWidth: "100px",
    maxWidth: "100px",
});

const StyledValue = styled("span")({
    fontWeight: "400",
    fontSize: "13px",
});

const StyledArchiveContainer = styled("div")({
    display: "flex",
    minWidth: "150px",
});

const ExhibitAInformation = (props) => {
    const { exhibitAs, handlePrependArrayElement, handleDeleteArrayElement, handleUpdateArrayElement } = props;
    const [focusedIndex, setFocusedIndex] = React.useState(null);

    const handleExpirationDateFocus = (index) => {
        setFocusedIndex(index);
    };

    const handleExpirationDateBlur = (index) => {
        setFocusedIndex(null);
    };

    let idArr = new Array(exhibitAs.length);
    return (
        <div>
            {exhibitAs.length >= 1 &&
                exhibitAs.map((element, index) => {
                    if (
                        focusedIndex === index ||
                        new Date(element["exhibitAExpirationDate"]) >= new Date() ||
                        element["exhibitAExpirationDate"] == null
                    ) {
                        return (
                            <ExhibitADetail
                                key={`new-exhibit-${element["exhibitAKey"] || idArr[index]}`}
                                element={element}
                                elementIndex={index}
                                onDelete={handleDeleteArrayElement}
                                handleUpdateArrayElement={handleUpdateArrayElement}
                                onExpirationDateFocus={handleExpirationDateFocus}
                                onExpirationDateBlur={handleExpirationDateBlur}
                                {...props}
                            />
                        );
                    } else return null;
                })}
            <StyledRootButton
                onClick={() => {
                    idArr = [`temp-${Date.now()}`, ...idArr];
                    handlePrependArrayElement("exhibitAs");
                }}
            >
                <Add />
                {"Add Exhibit A"}
            </StyledRootButton>
            {Array.isArray(exhibitAs) &&
                [...exhibitAs].map((element, index) => {
                    if (focusedIndex !== index && new Date(element["exhibitAExpirationDate"]) < new Date()) {
                        return (
                            <React.Fragment>
                                <StyledTable>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <IconButton
                                                    sx={{ padding: 0, minWidth: 0, margin: 0 }}
                                                    onClick={() => {
                                                        idArr.splice(index, 1);
                                                        handleDeleteArrayElement("exhibitAs", index);
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </td>
                                        </tr>
                                        <tr>
                                            <StyledArchiveLabel>{element["exhibitAType"]}</StyledArchiveLabel>
                                        </tr>
                                        <tr>
                                            <td>
                                                <StyledArchiveContainer>
                                                    <StyledArchiveLabel>BASE SPLIT %</StyledArchiveLabel>
                                                    <StyledValue>
                                                        {parseInt(element["baseSplitPercentage"])}
                                                    </StyledValue>
                                                </StyledArchiveContainer>
                                            </td>
                                            <td>
                                                <StyledArchiveContainer>
                                                    <StyledArchiveLabel>ANNUAL GROSS MINIMUM</StyledArchiveLabel>
                                                    <StyledValue>
                                                        {utilOperations.formatAmount(element["annualGrossMinimum"])}
                                                    </StyledValue>
                                                </StyledArchiveContainer>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <StyledArchiveContainer>
                                                    <StyledArchiveLabel>ADJUSTED %</StyledArchiveLabel>
                                                    <StyledValue>
                                                        {parseInt(element["adjustedPercentage"]).toFixed(2)}
                                                    </StyledValue>
                                                </StyledArchiveContainer>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <StyledArchiveContainer>
                                                    <StyledArchiveLabel>START DATE</StyledArchiveLabel>
                                                    <StyledValue>
                                                        {utilOperations.formatDate("MM-DD-YYYY")(
                                                            element["exhibitAStartDate"]
                                                        )}
                                                    </StyledValue>
                                                </StyledArchiveContainer>
                                            </td>
                                            <td>
                                                <StyledArchiveContainer>
                                                    <StyledArchiveLabel>EXPIRATION DATE</StyledArchiveLabel>
                                                    <StyledValue>
                                                        {utilOperations.formatDate("MM-DD-YYYY")(
                                                            element["exhibitAExpirationDate"]
                                                        )}
                                                    </StyledValue>
                                                </StyledArchiveContainer>
                                            </td>
                                        </tr>
                                    </tbody>
                                </StyledTable>
                                <BSInput
                                    id="comments"
                                    placeholder="Enter comments"
                                    value={element["comments"]}
                                    multiline
                                    rows={5}
                                    margin="normal"
                                    variant="outlined"
                                    disabled={true}
                                    label="COMMENTS"
                                />
                                <Divider flexItem />
                            </React.Fragment>
                        );
                    }
                    return null;
                })}
        </div>
    );
};

export default ExhibitAInformation;
